var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"e-button",class:[`${_vm.pattern}-${_vm.type}`, _vm.disabled ? 'is-disabled' : ''],style:({ width: _vm.width + 'px', height: _vm.height + 'px', lineHeight: _vm.height + 'px' }),on:{"click":function($event){return _vm._click()}}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }